import Details from './details/ClientServicePlanDetailsInitialState'

const { Record } = require('immutable')

export default Record({
    details: Details()
})